<template>
  <div>
    <Card title="Filtros">
      <div class="row mt-n2">
        <SearchFieldSelector
          :default-start-date="defaultStartDate"
          :default-end-date="defaultEndDate"
          :options="dateSelectOptions"
          :clean-date="cleanDate"
          @updateSearchValue="onChangeDate"
        />

        <md-button
          class="btn btn-primary"
          @click="submitSearch"
        >
          <span>Listar</span>
        </md-button>
      </div>
    </Card>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import Card from '@/components/common/Card.vue'
import SearchFieldSelector from '@/components/common/SearchFieldSelector.vue'
import notify from '@/api/notification'
import { PANIC_ALERT_PERIOD_DAYS_DEFAULT } from '@/enums'

export default {
  name: 'PanicAlertFilter',
  components: {
    Card,
    SearchFieldSelector
  },
  data() {
    return {
      today: new Date(),
      cleanDate: 0,
      dateSelected: { start: null, end: null },
      dateSelectOptions: [
        {
          itemValue: 'DATE',
          value: 'date',
          label: 'Período',
          placeholder: 'Período',
          limitDays: PANIC_ALERT_PERIOD_DAYS_DEFAULT,
          type: 'date',
          limitDays: 1827,
        }
      ],
    }
  },
  computed: {
    ...mapGetters(['panicAlertParams']),
    defaultStartDate() {
      return moment(this.today).subtract(PANIC_ALERT_PERIOD_DAYS_DEFAULT, 'days').toDate()
    },
    defaultEndDate() {
      return this.today
    }
  },
  mounted() {
    this.dateSelected = {
      start: this.panicAlertParams?.startDate,
      end: this.panicAlertParams?.endDate
    }
    this.getPanicAlertsTotalNumber()
  },
  methods: {
    ...mapActions([
      'selectPanicParams',
      'submitPanicAlertSearch',
      'getPanicAlertsTotalNumber',
      'setWaitingPanicAlertLoadingStatus'
    ]),

    onChangeDate({ date }) {
      if (this.isRangeValid(date)) {
        this.dateSelected = date
      } else {
        this.cleanDate++
        notify({
          title: 'AVISO:',
          message: `Selecione um período de até ${PANIC_ALERT_PERIOD_DAYS_DEFAULT} dias.`
        })
      }
    },

    isRangeValid(date) {
      if (!date.start || !date.end) return false

      const start = moment(date.start)
      const end = moment(date.end)
      return end.diff(start, 'days') <= PANIC_ALERT_PERIOD_DAYS_DEFAULT
    },

    async submitSearch() {
      const params = {
        ...this.panicAlertParams,
        startDate: this.dateSelected?.start,
        endDate: this.dateSelected?.end
      }

      this.selectPanicParams(params)

      await this.submitPanicAlertSearch()
      await this.getPanicAlertsTotalNumber()
    }
  }
}
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;

  div {
    flex: 1 1 auto;
    margin: 0;
  }
}
</style>
